import React, { useState } from "react";
import FichaPesquisa from "components/hooks/CardPesquisar";
import BaseSelector from "./BaseSelector";

export default function Navbar({ absolute }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [fichaData, setFichaData] = useState(null);

  const handleSearch = () => {
    if (searchQuery.trim()) {
      setFichaData(null);
      setTimeout(() => {
        setFichaData(searchQuery);
        setSearchQuery("");
      }, 0);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  };

  const handleChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <>
      {fichaData && <FichaPesquisa ficha={fichaData} />}
      <nav className={`${absolute} top-0 left-0 w-full z-10 bg-transparent flex items-center p-4`}>
        <div className="w-full mx-auto items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
          <div>
            <a
              className="text-white text-lc uppercase hidden lg:inline-block font-semibold"
              href="../"
            >
              LC Transportes
            </a>
            <div>
              <span className="text-white text-lcsm uppercase hidden lg:inline-block font-semibold">
                {localStorage.getItem("nome")}
              </span>
            </div>
          </div>

          <form
            className="relative flex flex-row flex-wrap items-center  lg:ml-auto mr-3"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="relative m-4 md:w-12/12 flex items-stretch">
              <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base flex items-center justify-center w-8 pl-3 py-3">
                <i className="fas fa-search"></i>
              </span>
              <input
                type="text"
                value={searchQuery}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder="Pesquisar..."
                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
              />

            </div>

          </form>
          <BaseSelector />

        </div>
      </nav>
    </>
  );
}
